import austriaFlag from "../assets/imgs/austria.png";
import australiaFlag from "../assets/imgs/australia.png";
import belgiumFlag from "../assets/imgs/belgium.png";
import croatiaFlag from "../assets/imgs/croatia.png";
import cyprusFlag from "../assets/imgs/cyprus.png";
import czechFlag from "../assets/imgs/czech.png";
import denmarkFlag from "../assets/imgs/denmark.png";
import estoniaFlag from "../assets/imgs/estonia.png";
import ecuadorFlag from "../assets/imgs/ecuador.png";
import finlandFlag from "../assets/imgs/finland.png";
import franceFlag from "../assets/imgs/france.png";
import germanyFlag from "../assets/imgs/germany.png";
import greeceFlag from "../assets/imgs/greece.png";
import hungaryFlag from "../assets/imgs/hungary.png";
import icelandFlag from "../assets/imgs/iceland.png";
import irelandFlag from "../assets/imgs/ireland.png";
import italyFlag from "../assets/imgs/italy.png";
import latviaFlag from "../assets/imgs/latvia.png";
import LiechtensteinFlag from "../assets/imgs/Liechtenstein.png";
import LithuaniaFlag from "../assets/imgs/Lithuania.png";
import LuxembourgFlag from "../assets/imgs/Luxembourg.png";
import maltaFlag from "../assets/imgs/malta.png";
import mexicoFlag from "../assets/imgs/mexico.png";
import monacoFlag from "../assets/imgs/monaco.png";
import netherlandsFlag from "../assets/imgs/netherlands.png";
import norwayFlag from "../assets/imgs/norway.png";
import polandFlag from "../assets/imgs/poland.png";
import portugalFlag from "../assets/imgs/portugal.png";
import romaniaFlag from "../assets/imgs/romania.png";
import san_marinoFlag from "../assets/imgs/san_marino.png";
import slovakiaFlag from "../assets/imgs/slovakia.png";
import sloveniaFlag from "../assets/imgs/slovenia.png";
import SpainFlag from "../assets/imgs/Spain.png";
import swedenFlag from "../assets/imgs/sweden.png";
import turkeyFlag from "../assets/imgs/turkey.png";
import united_kingdomFlag from "../assets/imgs/united_kingdom.png";
import united_states_of_americaFlag from "../assets/imgs/united_states_of_america.png";

export const countries = [
  {
    name: "Austria",
    flag: austriaFlag,
    currency: "EUR",
    ISO: "AT",
  },
  {
    name: "Australia",
    flag: australiaFlag,
    currency: "AUD",
    ISO: "AU",
  },
  {
    name: "Belgium",
    flag: belgiumFlag,
    currency: "EUR",
    ISO: "BE",
  },
  {
    name: "Croatia",
    flag: croatiaFlag,
    currency: "EUR",
    ISO: "HR",
  },
  {
    name: "Cyprus",
    flag: cyprusFlag,
    currency: "EUR",
    ISO: "CY",
  },
  {
    name: "Czech Republic",
    flag: czechFlag,
    currency: "CZK",
    ISO: "CZ",
  },
  {
    name: "Czech Republic",
    flag: czechFlag,
    currency: "EUR",
    ISO: "CZ",
  },
  {
    name: "Denmark",
    flag: denmarkFlag,
    currency: "DKK",
    ISO: "DK",
  },
  {
    name: "Denmark",
    flag: denmarkFlag,
    currency: "EUR",
    ISO: "DK",
  },
  {
    name: "Estonia",
    flag: estoniaFlag,
    currency: "EUR",
    ISO: "EE",
  },
  {
    name: "Ecuador",
    flag: ecuadorFlag,
    currency: "USD",
    ISO: "EC",
  },
  {
    name: "Finland",
    flag: finlandFlag,
    currency: "EUR",
    ISO: "FI",
  },
  {
    name: "France",
    flag: franceFlag,
    currency: "EUR",
    ISO: "FR",
  },
  {
    name: "Germany",
    flag: germanyFlag,
    currency: "EUR",
    ISO: "DE",
  },
  {
    name: "Greece",
    flag: greeceFlag,
    currency: "EUR",
    ISO: "GR",
  },
  {
    name: "Hungary",
    flag: hungaryFlag,
    currency: "HUF",
    ISO: "HU",
  },
  {
    name: "Hungary",
    flag: hungaryFlag,
    currency: "EUR",
    ISO: "HU",
  },
  {
    name: "Iceland",
    flag: icelandFlag,
    currency: "ISK",
    ISO: "AT",
  },
  {
    name: "Iceland",
    flag: icelandFlag,
    currency: "EUR",
    ISO: "IS",
  },
  {
    name: "Ireland",
    flag: irelandFlag,
    currency: "EUR",
    ISO: "IE",
  },
  {
    name: "Italy",
    flag: italyFlag,
    currency: "EUR",
    ISO: "IT",
  },
  {
    name: "Latvia",
    flag: latviaFlag,
    currency: "EUR",
    ISO: "LV",
  },
  {
    name: "Liechtenstein",
    flag: LiechtensteinFlag,
    currency: "EUR",
    ISO: "LI",
  },
  {
    name: "Lithuania",
    flag: LithuaniaFlag,
    currency: "EUR",
    ISO: "LT",
  },
  {
    name: "Luxembourg",
    flag: LuxembourgFlag,
    currency: "EUR",
    ISO: "LU",
  },
  {
    name: "Malta",
    flag: maltaFlag,
    currency: "EUR",
    ISO: "MT",
  },
  {
    name: "Mexico",
    flag: mexicoFlag,
    currency: "MXN",
    ISO: "MX",
  },
  {
    name: "Monaco",
    flag: monacoFlag,
    currency: "EUR",
    ISO: "MC",
  },
  {
    name: "Netherlands",
    flag: netherlandsFlag,
    currency: "EUR",
    ISO: "NL",
  },
  {
    name: "Norway",
    flag: norwayFlag,
    currency: "NOK",
    ISO: "NO",
  },
  {
    name: "Norway",
    flag: norwayFlag,
    currency: "EUR",
    ISO: "NO",
  },
  {
    name: "Poland",
    flag: polandFlag,
    currency: "PLN",
    ISO: "PL",
  },
  {
    name: "Poland",
    flag: polandFlag,
    currency: "EUR",
    ISO: "PL",
  },
  {
    name: "Portugal",
    flag: portugalFlag,
    currency: "EUR",
    ISO: "PT",
  },
  {
    name: "Romania",
    flag: romaniaFlag,
    currency: "RON",
    ISO: "RO",
  },
  {
    name: "Romania",
    flag: romaniaFlag,
    currency: "EUR",
    ISO: "RO",
  },
  {
    name: "San Marino",
    flag: san_marinoFlag,
    currency: "EUR",
    ISO: "SM",
  },
  {
    name: "Slovakia",
    flag: slovakiaFlag,
    currency: "EUR",
    ISO: "SK",
  },
  {
    name: "Slovenia",
    flag: sloveniaFlag,
    currency: "EUR",
    ISO: "SI",
  },
  {
    name: "Spain",
    flag: SpainFlag,
    currency: "EUR",
    ISO: "ES",
  },
  {
    name: "Sweden",
    flag: swedenFlag,
    currency: "SEK",
    ISO: "SE",
  },
  {
    name: "Sweden",
    flag: swedenFlag,
    currency: "EUR",
    ISO: "SE",
  },
  {
    name: "Turkey",
    flag: turkeyFlag,
    currency: "TRY",
    ISO: "TR",
  },
  {
    name: "United Kingdom",
    flag: united_kingdomFlag,
    currency: "GBP",
    ISO: "GB",
  },
  {
    name: "United States Of America",
    flag: united_states_of_americaFlag,
    currency: "USD",
    ISO: "US",
  },
];
